import { render, staticRenderFns } from "./Vlaamserand.vue?vue&type=template&id=f264b36c&"
import script from "./Vlaamserand.vue?vue&type=script&lang=js&"
export * from "./Vlaamserand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports